import { Terminator } from "@opendaw/lib-std";
import { UserEditing } from "./UserEditing";
export class UserEditingManager {
    #terminator;
    #modularSystem;
    #timeline;
    #audioUnit;
    constructor(editing) {
        this.#terminator = new Terminator();
        this.#modularSystem = this.#terminator.own(new UserEditing(editing));
        this.#timeline = this.#terminator.own(new UserEditing(editing));
        this.#audioUnit = this.#terminator.own(new UserEditing(editing));
    }
    follow(userInterfaceBox) {
        this.#modularSystem.follow(userInterfaceBox.editingModularSystem);
        this.#timeline.follow(userInterfaceBox.editingTimelineRegion);
        this.#audioUnit.follow(userInterfaceBox.editingDeviceChain);
    }
    get modularSystem() { return this.#modularSystem; }
    get timeline() { return this.#timeline; }
    get audioUnit() { return this.#audioUnit; }
    terminate() { this.#terminator.terminate(); }
}
